module.exports = __webpack_public_path__ + "media/add/time-travel-3e6ae713.jpg";